var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":_vm.linkTo}},[_vm._v(" "+_vm._s(_vm.displayName)+" "),_c('span',{staticClass:"caption"},[_vm._v("("+_vm._s(_vm._f("millify")(_vm.role.works_count))+")"+_vm._s((_vm.appendComma) ? "," : ""))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }